import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form } from 'react-bootstrap';
import api from '../../utils/api';

const WorkManager = () => {
  const [works, setWorks] = useState([]);
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    company: '',
    title: '',
    description: '',
    startDate: '',
    endDate: '',
    isCurrent: false,
    logo: null,
  });
  const [editingId, setEditingId] = useState(null);

  const fetchWorks = async () => {
    try {
      const { data } = await api.get('/work');
      setWorks(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchWorks();
  }, []);

  const handleClose = () => {
    setShow(false);
    setEditingId(null);
    setFormData({
      company: '',
      title: '',
      description: '',
      startDate: '',
      endDate: '',
      isCurrent: false,
      logo: null,
    });
  };

  const handleShow = (work = null) => {
    if (work) {
      setEditingId(work._id);
      setFormData({
        company: work.company,
        title: work.title,
        description: work.description,
        startDate: work.startDate.split('T')[0],
        endDate: work.endDate ? work.endDate.split('T')[0] : '',
        isCurrent: work.isCurrent,
        logo: null, // Don't preload file input
      });
    }
    setShow(true);
  };

  const handleChange = (e) => {
    if (e.target.name === 'logo') {
      setFormData({ ...formData, logo: e.target.files[0] });
    } else if (e.target.name === 'isCurrent') {
      setFormData({ ...formData, isCurrent: e.target.checked });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== null) {
          data.append(key, formData[key]);
      }
    });

    try {
      if (editingId) {
        await api.put(`/work/${editingId}`, data);
      } else {
        await api.post('/work', data);
      }
      fetchWorks();
      handleClose();
    } catch (error) {
      console.error(error);
      alert('Error saving data');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure?')) {
      try {
        await api.delete(`/work/${id}`);
        fetchWorks();
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Work Experience</h3>
        <Button onClick={() => handleShow()}>Add New</Button>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Company</th>
            <th>Title</th>
            <th>Dates</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {works.map((work) => (
            <tr key={work._id}>
              <td>{work.company}</td>
              <td>{work.title}</td>
              <td>{new Date(work.startDate).toLocaleDateString()} - {work.isCurrent ? 'Present' : new Date(work.endDate).toLocaleDateString()}</td>
              <td>
                <Button variant="info" size="sm" className="me-2" onClick={() => handleShow(work)}>Edit</Button>
                <Button variant="danger" size="sm" onClick={() => handleDelete(work._id)}>Delete</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{editingId ? 'Edit Work' : 'Add Work'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Company</Form.Label>
              <Form.Control name="company" value={formData.company} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control name="title" value={formData.title} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={3} name="description" value={formData.description} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Start Date</Form.Label>
              <Form.Control type="date" name="startDate" value={formData.startDate} onChange={handleChange} required />
            </Form.Group>
            <Form.Check 
              type="checkbox" 
              label="Currently working here" 
              name="isCurrent" 
              checked={formData.isCurrent} 
              onChange={handleChange} 
              className="mb-3"
            />
            {!formData.isCurrent && (
              <Form.Group className="mb-3">
                <Form.Label>End Date</Form.Label>
                <Form.Control type="date" name="endDate" value={formData.endDate} onChange={handleChange} />
              </Form.Group>
            )}
            <Form.Group className="mb-3">
              <Form.Label>Logo (Optional)</Form.Label>
              <Form.Control type="file" name="logo" onChange={handleChange} />
            </Form.Group>
            <Button variant="primary" type="submit">Save Changes</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default WorkManager;
